import React, { memo } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import CheckIcon from 'images/v5/icons/check.svg';
import Button from 'layout/atoms/Button/Button';
import ConfirmationModal from 'layout/molecules/ConfirmationModal';
import { closeModal, selectModalByName } from 'store/layoutSlice';
import { setSpecificationStateToProduction } from 'store/specificationDetailsSlice';
function ApproveSpecificationModal() {
    var _a;
    const { t } = useTranslation(['specification']);
    const dispatch = useDispatch();
    const modalData = (_a = useSelector(selectModalByName('approveSpecification'))) === null || _a === void 0 ? void 0 : _a.data;
    const modelSpecificationId = modalData === null || modalData === void 0 ? void 0 : modalData.id;
    const isCreatorContext = modalData === null || modalData === void 0 ? void 0 : modalData.creator;
    const settingToProduction = useSelector((state) => state.specificationDetails.status.setToProduction === 'loading');
    const handleApprove = () => {
        if (!modelSpecificationId || settingToProduction)
            return;
        dispatch(setSpecificationStateToProduction({ modelSpecificationId }))
            .unwrap()
            .then(() => {
            dispatch(closeModal({ name: 'approveSpecification' }));
            if (isCreatorContext) {
                dispatch(closeModal({ name: 'specificationCreator' }));
            }
        })
            .catch(() => undefined);
    };
    return (React.createElement(ConfirmationModal, { name: "approveSpecification", header: React.createElement(React.Fragment, null,
            React.createElement(CheckIcon, null),
            t('approve_draft')), buttons: React.createElement(Button, { color: "success", onClick: handleApprove, loading: settingToProduction }, t('common:confirm')), action: handleApprove, loading: settingToProduction },
        React.createElement("p", null, t('approve_draft_confirmation_message'))));
}
export default memo(ApproveSpecificationModal);
